<template>
  <section id="login-register">
    <div id="login-register-content">
      <div  v-if="waitingForServer" class="loading-overlay">
        <img src="../assets/img/loading.gif" alt="loading..." />
      </div>
      <main>
        <section id="login">
          <template v-if="!forgotPassword">
            <template v-if="returningUser">
              <h2>Anmelden</h2>
              <p class="returning-switch">Neu hier? <span class="returning-toggle" @click="toggleReturningUser()">Jetzt registrieren!</span></p>
            </template>
            <template v-else>
              <h2>Registrieren</h2>
              <p class="returning-switch">Sie haben bereits ein Konto? <span class="returning-toggle" @click="toggleReturningUser()">Hier anmelden!</span></p>
            </template>
            <form @submit="signin">
              <input v-model="customer.mail" type="email" autocomplete="email" placeholder="E-Mail-Adresse" :class="errorClasses.mail" />
              <input v-if="returningUser" v-model="customer.pw" type="password" autocomplete="current-password" placeholder="Ihr Passwort" :class="errorClasses.pw" />
              <input v-if="!returningUser" v-model="customer.pw" type="password" autocomplete="new-password" placeholder="Neues Passwort" :class="errorClasses.pw" />
              <fieldset v-if="!returningUser" id="profileData">
                <h3>An wen dürfen wir das Angebot richten?</h3>
                <input type="text" v-model="customer.company" autocomplete="organization" placeholder="Firmenname" :class="errorClasses.company" />
                <input type="text" v-model="customer.name" autocomplete="name" placeholder="Ansprechpartner" :class="errorClasses.name" />
              </fieldset>
              <fieldset v-if="!returningUser" id="disclaimer">
                <span class="descWrap">
                  <input type="checkbox" id="agb" :class="errorClasses.checkedAgb" v-model="customer.checkedAgb" />
                  <label for="agb" class="smallText"><span>Ich akzeptiere die <a href="https://clickzip.de/agb.pdf" target="_blank">Allgemeinen Geschäftsbedingungen</a></span></label>
                </span>
                <span class="descWrap">
                  <input type="checkbox" id="datenschutz" :class="errorClasses.checkedPrivacy" v-model="customer.checkedPrivacy" />
                  <label for="datenschutz" class="smallText"><span>Ich stimme der Speicherung und Verarbeitung der übermittelten Daten zu. Ich habe die <a href="https://about.clickzip.de/datenschutzerklaerung/" target="_blank">Datenschutzerklärung</a> gelesen und akzeptiert.</span></label>
                </span>
              </fieldset>
              <input :class="submitClasses" type="submit" v-model="submitText" />
            </form>
          </template>
          <template v-if="forgotPassword">
            <h2>Passwort zurücksetzen</h2>
            <form @submit="resetPassword">
              <fieldset>
              <input v-model="customer.mail" type="email" autocomplete="email" placeholder="E-Mail-Adresse" />
              <input class="loginbutton" type="submit" value="Passwort zurücksetzen" />
              </fieldset>
            </form>
            <p v-if="resetSuccess" class="successMessage">E-Mail zum Zurücksetzen versendet. Bitte folgen Sie den Anweisungen in der Mail.</p>
          </template>
          <template v-if="error">
            <ul class="errorList" v-for="error of errorMessages" :key="error.code">
              <li v-if="error.active" class="errorMessage">{{error.content}}</li>
            </ul>
          </template>
          <button v-if="returningUser" id="forgot-button" @click="togglePasswordForgot()">{{forgotText}}</button>
        </section>
      </main>
    </div>
  </section>
</template>

<script>
// import { db, auth } from '../firebase'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
export default {
  name: 'LoginModal',
  data: function () {
    return {
      waitingForServer: false,
      forgotPassword: false,
      customer: {
        mail: '',
        pw: '',
        company: '',
        name: '',
        checkedAgb: false,
        checkedPrivacy: false
      },
      errorClasses: {
        mail: '',
        pw: '',
        company: '',
        name: '',
        checkedAgb: '',
        checkedPrivacy: ''
      },
      errorMessages: [
        {
          code: 'emptyField',
          active: false,
          content: 'Bitte füllen Sie alle Felder aus.'
        },
        {
          code: 'invalidField',
          active: false,
          content: 'Alle Felder müssen korrekt ausgefüllt sein.'
        },
        {
          code: 'badMail',
          active: false,
          content: 'Bitte geben Sie eine korrekte E-Mail-Adresse ein.'
        },
        {
          code: 'shortPassword',
          active: false,
          content: 'Das Passwort ist zu kurz.'
        },
        {
          code: 'missingAGB',
          active: false,
          content: 'Sie müssen den AGB akzeptieren, um sich registrieren zu können.'
        },
        {
          code: 'missingPrivacy',
          active: false,
          content: 'Sie müssen mit unseren Datenschutzbestimmungen einverstanden sein, um sich registrieren zu können.'
        },
        {
          code: 'missingCompany',
          active: false,
          content: 'Sie müssen einen Firmennamen angeben, um sich registrieren zu können.'
        },
        {
          code: 'missingName',
          active: false,
          content: 'Sie müssen einen Ansprechpartner angeben, um sich registrieren zu können.'
        },
        {
          code: 'badLogin',
          active: false,
          content: 'Login nicht erfolgreich. Bitte überprüfen Sie Ihre Eingaben.'
        },
        {
          code: 'resetError',
          active: false,
          content: 'Bitte überprüfen Sie die eingegebene E-Mail.'
        },
        {
          code: 'unknown',
          active: false,
          content: 'Unbekannter Fehler aufgetreten.'
        }
      ],
      error: false,
      returningUser: false,
      resetSuccess: false,
      user: null
    }
  },
  computed: {
    forgotText: function () {
      if (this.forgotPassword) {
        return 'Zurück zur Anmeldung'
      } else {
        return 'Passwort vergessen?'
      }
    },
    submitText: function () {
      if (this.returningUser) {
        return 'Anmelden'
      } else {
        return 'Registrieren'
      }
    },
    submitClasses: function () {
      if (this.returningUser) {
        return 'loginbutton'
      } else {
        return 'loginbutton bugFix'
      }
    }
  },
  methods: {
    togglePasswordForgot: function () {
      this.error = false
      this.resetSuccess = false
      this.customer.mail = ''
      this.resetErrorClasses()
      this.forgotPassword = !this.forgotPassword
    },
    resetPassword: function (e) {
      e.preventDefault()
      this.resetErrors()
      this.resetSuccess = false
      this.error = false
      if (this.validateEmail(this.customer.mail)) {
        this.waitingForServer = true
        firebase.auth().sendPasswordResetEmail(this.customer.mail).then(reset => {
          // Email sent.
          this.waitingForServer = false
          this.resetSuccess = true
        }).catch(error => {
          this.waitingForServer = false
          this.error = true
          this.errorMessages.find(error => error.code === 'resetError').active = true
          console.warn(error.code)
        })
      } else {
        this.error = true
        this.errorMessages.find(error => error.code === 'badMail').active = true
      }
    },
    resetErrors: function () {
      for (let i = 0; i < this.errorMessages.length; i++) {
        this.errorMessages[i].active = false
      }
    },
    toggleReturningUser: function () {
      this.returningUser = !this.returningUser
      this.resetErrorClasses()
      this.error = false
    },
    resetErrorClasses: function () {
      for (var error in this.errorClasses) {
        this.errorClasses[error] = ''
      }
    },
    checkInputs: function () {
      this.error = false
      for (var property in this.customer) {
        if (this.customer[property].length === 0 || this.customer[property] === false) { // empty string or unchecked
          switch (property) {
            case 'mail':
            case 'pw':
              this.errorClasses[property] = 'errorField'
              this.error = true
              this.errorMessages.find(error => error.code === 'emptyField').active = true
              break
            case 'company':
              if (!this.returningUser) {
                this.errorClasses[property] = 'errorField'
                this.error = true
                this.errorMessages.find(error => error.code === 'missingCompany').active = true
              }
              break
            case 'name':
              if (!this.returningUser) {
                this.errorClasses[property] = 'errorField'
                this.error = true
                this.errorMessages.find(error => error.code === 'missingName').active = true
              }
              break
            case 'checkedAgb':
              if (!this.returningUser) {
                this.errorClasses[property] = 'errorField'
                this.error = true
                this.errorMessages.find(error => error.code === 'missingAGB').active = true
              }
              break
            case 'checkedPrivacy':
              if (!this.returningUser) {
                this.errorClasses[property] = 'errorField'
                this.error = true
                this.errorMessages.find(error => error.code === 'missingPrivacy').active = true
              }
              break
          }
        } else { // not empty, check input if valid
          switch (property) {
            case 'mail':
              if (!this.validateEmail(this.customer[property])) {
                this.errorClasses[property] = 'errorField'
                this.error = true
                this.errorMessages.find(error => error.code === 'invalidField').active = true
              }
              break
            case 'pw':
              if (this.customer[property].length < 6) { // password too short
                this.errorClasses[property] = 'errorField'
                this.error = true
                this.errorMessages.find(error => error.code === 'shortPassword').active = true
              }
              break
          }
        }
      }
    },
    validateEmail: function (mail) {
      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return true
      }
      return false
    },
    signin: function (e) {
      e.preventDefault()
      this.resetErrors()
      this.resetErrorClasses()
      this.checkInputs()
      if (!this.error) {
        this.waitingForServer = true
        if (this.returningUser) {
          this.login()
        } else {
          this.signup()
        }
      }
    },
    login: function () {
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL).then(x => { // NONE
        // Existing and future Auth states are now persisted in the current
        // session only. Closing the window would clear any existing state even
        // if a user forgets to sign out.
        // ...
        // New sign-in will be persisted with session persistence.
        return firebase.auth().signInWithEmailAndPassword(this.customer.mail, this.customer.pw).then(user => {
          // Sign in success
          // this.$root.user = firebase.auth().currentUser.uid
          // this.$emit('loggedIn')
          // this.$root.addConfiguration()
          if (this.$root.saveWaiting) {
            this.$root.addConfiguration()
          }
        }).catch(error => {
          // Sign in error
          // var errorCode = error.code
          // var errorMessage = error.message
          // alert('ERROR: ' + errorCode + '...' + errorMessage)
          console.error(error.code)
          this.error = true
          // if (error.code === 'auth/user-not-found') {
          // this.errorMessage = 'Login nicht erfolgreich. Bitte überprüfen Sie Ihre Eingaben.'
          // }
          this.errorMessages.find(error => error.code === 'badLogin').active = true
          this.waitingForServer = false
        })
      }).catch(error => {
        // Handle Errors here.
        alert(error)
      })
      /*
      firebase.auth().signInWithEmailAndPassword(this.customer.mail, this.customer.pw).then(user => {
        // Sign in success
        this.$root.user = firebase.auth().currentUser.uid
        // this.$emit('loggedIn')
      }).catch(error => {
        // Sign in error
        // var errorCode = error.code
        // var errorMessage = error.message
        // alert('ERROR: ' + errorCode + '...' + errorMessage)
        console.error(error.code)
        this.error = true
        // if (error.code === 'auth/user-not-found') {
        // this.errorMessage = 'Login nicht erfolgreich. Bitte überprüfen Sie Ihre Eingaben.'
        // }
        this.errorMessages.find(error => error.code === 'badLogin').active = true
        this.waitingForServer = false
      })
      */
    },
    signup: function () {
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL).then(x => { // NONE
        // Existing and future Auth states are now persisted in the current
        // session only. Closing the window would clear any existing state even
        // if a user forgets to sign out.
        // ...
        // New sign-in will be persisted with session persistence.
        return firebase.auth().createUserWithEmailAndPassword(this.customer.mail, this.customer.pw).then(user => {
          // Sign in success
          // this.$root.user = firebase.auth().currentUser.uid
          // this.$emit('loggedIn')
          this.createUser()
          // this.$root.addConfiguration()
          if (this.$root.saveWaiting) {
            this.$root.addConfiguration()
          }
        }).catch(error => {
          console.error(error.code)
          this.error = true
          this.errorMessages.find(error => error.code === 'unknown').active = true
          this.waitingForServer = false
        })
      }).catch(error => {
        alert(error)
      })
    },
    createUser: function () {
      firebase.firestore().collection('users').doc(this.$root.currentUser.uid).set({
        companyName: this.customer.company,
        companyLegal: 'Rechtsform',
        userName: this.customer.name,
        addressStreet: 'Straße und Hausnummer',
        addressZip: 'Postleitzahl',
        addressLocation: 'Ort',
        addressAddition: 'Adresszusatz',
        phone: 'Telefonnummer',
        mail: firebase.auth().currentUser.email,
        // mailValidation: false,
        newsletter: false,
        imgPath: ''
        // createdAt: firebase.firestore.FieldValue.serverTimestamp()
        // creationDate: Timestamp.fromDate(new Date('December 10, 1815'))
      }).then(function () {
        firebase.auth().currentUser.sendEmailVerification().then(function () {
          // Email sent.
          console.log('Verification sent!')
        }).catch(function (error) {
          // An error happened.
          console.log('Error while sending verification!', error)
        })
        console.log('Document successfully written!')
      }).catch(function (error) {
        console.error('Error writing document: ', error)
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/css/variables.scss";
#login-register {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width:620px;
  max-width: 100%;
  height: auto;
  padding: 20px 15px 20px 15px;
  z-index: 2;
  #login-register-content {
    border-radius: 12px;
    width:100%;
    min-height: 100%;
    position: relative;
    background: #fff;
    box-shadow: 0px 8px 26px 0px rgba(0,0,0,0.2);
    z-index: 98;
    overflow: auto;
    padding: 0 0 15px 0;
    .loading-overlay {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: rgba(255,255,255,0.9);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
      img {
        width: 80px;
        height: 80px;
      }
    }
    main {
      padding: 40px 40px 20px 40px;
      h2 {
        font-family: $primaryFont;
        font-weight: $primaryFontBold;
        color: $primaryFontColor;
        font-size: 28px;
        margin: 0 0 10px 0;
        line-height: 1.2;
      }
      h3 {
        font-family: $primaryFont;
        font-weight: $primaryFontBold;
        color: $primaryFontColor;
        font-size: 18px;
        margin: 0 0 10px 0;
        line-height: 1.2;
      }
      .returning-switch {
        font-size: 16px;
        margin: 0 0 20px 0;
        .returning-toggle {
          margin: 0;
          user-select: none;
          text-decoration: underline;
          &:hover {
            cursor: pointer;
          }
        }
      }
      form {
        margin: 0 0 0 0;
        fieldset {
          margin: 20px 0 0 0;
        }
        input[type="text"],
        input[type="email"],
        input[type="number"],
        input[type="password"] {
          display: block;
          -webkit-appearance: none;
          -moz-appearance: none;
          -ms-appearance: none;
          -o-appearance: none;
          appearance: none;
          outline: none;
          box-sizing: border-box;
          padding: 6px 16px;
          line-height: 1.8;
          font-size: 18px;
          margin-bottom: 8px;
          border-radius: 8px;
          width: 100%;
          border: 2px solid #DDD;
          color: $primaryFontColor;
          transition: border 0.1s;
          &.errorField {
            border-color: #ea1717;
          }
        }
        input[type="text"]:focus,
        input[type="email"]:focus,
        input[type="number"]:focus,
        input[type="password"]:focus {
          border-color: $primaryColor;
        }
        input[type="checkbox"] {
          display: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          -ms-appearance: none;
          -o-appearance: none;
          appearance: none;
          outline: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          box-sizing: border-box;
          padding: 0;
          border:none;
          width: 0;
          height: 0;
          outline: 0;
          opacity: 0;
        }
        input[type="checkbox"] + label {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
        }
        input[type="checkbox"] + label span {
          flex-shrink: 10;
        }
        input[type="checkbox"] + label:before {
          display:block;
          width: 20px;
          height: 20px;
          border-radius: 3px;
          content: '';
          background: #fff;
          margin-right: 8px;
          border: 2px solid #DDD;
          transition: 0.1s;
          flex-shrink: 1;
        }
        input[type="checkbox"]:hover + label:before {
          background: #FAFAFA;
          border-color: $primaryColor;
        }
        input[type="checkbox"].errorField + label:before {
          border-color: #ea1717;
        }
        input[type="checkbox"]:checked + label:after {
          display:block;
          width: 14px;
          height: 16px;
          background-image: url('../assets/img/icons/checkboxCheck.svg');
          background-size: 14px 16px;
          content: '';
          position: absolute;
          left: 3px;
          top: 50%;
          transform: translateY(-50%);
        }
        .descWrap {
          font-size: 14px;
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          label {
            margin: 0;
            &:hover {
              cursor: pointer;
            }
          }
          input {
            margin-right: 8px;
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
      .errorList {
        margin: 0;
        padding:0;
        .errorMessage {
          list-style: none;
          color: $errorColorPrimary;
          background-color: $errorColorSecondary;
          font-family: $secondaryFont;
          font-weight: $secondaryFontNormal;
          font-size: 16px;
          margin: 15px 0 15px 0;
          padding: 12px 16px;
          border-radius: 8px;
          // border: 2px solid #ff7e7e;
        }
      }
      .successMessage {
        color: #1e9d2c;
        background-color: #d6ffd0;
        font-family: $secondaryFont;
        font-weight: $secondaryFontNormal;
        font-size: 16px;
        margin: 15px 0 15px 0;
        padding: 12px 16px;
        border-radius: 8px;
      }
    }
    /*
    footer {
      background: #f7f7f7;
      padding: 40px 40px 60px 40px;
      text-align: center;
      h2 {
        font-family: $primaryFont;
        font-weight: $primaryFontBold;
        color: $secondaryHeadingColor;
        font-size: 20px;
      }
      .returning {
        margin: 0;
        user-select: none;
        font-size: 16px;
        text-decoration: underline;
        &:hover {
          cursor: pointer;
        }
      }
    }
    */
  }
}
@media (min-height: 460px) {
  #login-register {
    padding: 20px 15px 40px 15px;
  }
}
@media (min-height: 660px) {
  #login-register {
    padding: 40px 15px 40px 15px;
  }
}
main {
  font-family: $secondaryFont;
  color: $primaryFontColor;
  font-weight: $secondaryFontNormal;
  font-size: 22px;
}

#forgot-button {
  border: none;
  background: transparent;
  background: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  -webkit-appearance: none;
  color: $primaryFontColor;
  font-family: $secondaryFont;
  font-weight: $secondaryFontNormal;
  text-decoration: underline;
  font-size: 16px;
  margin: 0;
  padding: 0;
}
.loginbutton {
  overflow: hidden;
  text-align: center;
  width:100%;
  display: block;
  width: auto;
  font-family: $secondaryFont;
  font-weight: $secondaryFontBold;
  padding:10px 30px 10px 30px;
  margin: 20px 0 15px 0;
  width: 100%;
  border: none;
  background: transparent;
  background: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  -webkit-appearance: none;
  display:inline-block;
  overflow:hidden;
  font-size:18px;
  line-height:1;
  border-radius:25px;
  position:relative;
  transform: translate3d(0,0,0); // ripple bug
  span {
    z-index: 9;
    background: red;
    width: 100%;
    height: 100%;
  }
  &.bugFix {
    line-height: 1.01;
  }
}
.loginbutton::-moz-focus-inner {
  border: 0;
  padding: 0;
}
.loginbutton,
.loginbutton:hover,
.loginbutton:focus,
.loginbutton:active,
.loginbutton:visited {
  cursor: pointer;
  background:#5373FF;
  color:#fff;
  text-decoration:none;
}

</style>
